import type { DeskEntry } from '@/api/pending'
import type { Batch } from '@/lib/desk'
import { Icon, type IconName } from '@/ui'
import { cx } from '@/ui/cx'
import styles from './desk.module.css'

function iconFor(entry: Batch | DeskEntry): IconName {
  if (entry.kind === 'guest') return 'person'
  if (entry.kind === 'batch') return 'inventory_2'
  return entry.item_type === 'letter' ? 'mail' : 'move_to_inbox'
}

/** 40px circle: green for items and batches, amber for guests; a batch of 2+ gets a count bubble. */
export function DeskIcon({ entry, size = 40 }: { entry: Batch | DeskEntry; size?: number }) {
  return (
    <div
      className={cx(styles.deskIcon, entry.kind === 'guest' && styles.deskIconGuest)}
      style={{ width: size, height: size }}
    >
      <Icon name={iconFor(entry)} size={Math.round(size * 0.46)} />
      {entry.kind === 'batch' && entry.count > 1 && (
        <span className={styles.bubble} aria-hidden="true">
          {entry.count}
        </span>
      )}
    </div>
  )
}
